import { ModelSagres } from "../../model-sagres"

export class ContaCaixaResumida extends ModelSagres {
    idPcm: number
    codBanco: string
    codAgencia: string
    nroConta: string
    nroContaNovo: string

    constructor(obj?: any) {
        super()
        if (obj.IdPrestacaoConta) this.idPcm = obj.IdPrestacaoConta
        if (obj.CodigoBanco) this.codBanco = obj.CodigoBanco
        if (obj.CodigoAgencia) this.codAgencia = obj.CodigoAgencia
        if (obj.NumeroContBancaria) this.nroConta = obj.NumeroContBancaria
        if (obj.NumeroContBancariaNovo) this.nroContaNovo = obj.NumeroContBancariaNovo
    }
}
